import React, {useState, useEffect} from 'react';
import dynamic from 'next/dynamic';

// plyr accesses `document` at import time, which crashes SSR
const Plyr = dynamic(() => import('plyr-react'), {ssr: false});

const MemoizedPlyr = React.memo(({videoID, autoplay = false}) => (
  <Plyr
    options={{
      autoplay,
      controls: [
        'play',
        'play-large',
        'progress',
        'duration',
        'mute',
        'volume',
        'settings',
        'fullscreen',
      ],
      captions: {active: true}, // Force captions
    }}
    source={{
      type: 'video',
      sources: [
        {
          src: videoID,
          provider: 'youtube',
        },
      ],
    }}
  />
));

const YouTubeVideo = ({
  videoID,
  onView,
  onPlay,
  autoplay = false,
}) => {
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    onView?.();
  }, []);

  const handlePlay = () => {
    if (!clicked) {
      onPlay?.();
      setClicked(true);
    }
  };

  return (
    <button
      className="flex relative justify-center rounded overflow-hidden cursor-pointer w-full"
      onClick={handlePlay}
      type="button"
      aria-label="Play video"
    >
      <div
        className="w-full"
        style={{'--plyr-color-main': '#5524e0'}}
      >
        <MemoizedPlyr videoID={videoID} autoplay={autoplay} />
      </div>
    </button>
  );
};

export default YouTubeVideo;
